import config from "../config/config.json";
import { headers } from "../APIHelpers/Headers";
import CryptoJS from 'crypto-js';
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const studyRandomizerMetadataServices = {
  //Randomizer Metadata
  addRandomizerStudyParameter,
  findRandomizerStudyParameter,
  addNewRandomizerMetadata,
  updateRandomizerMeta,
  getHeighestVersionEventFormSchemaHistory,
  deleteRandomizerMeta,
  softDeleteRestoreRandomizerMetadata,
  getRandomizerMetadata,
  getRandomizerMetadataAuditTrials,
  getAssignedRandomizerList,
  getFactorsBasedonRandomizationId,
  generateWithFactorRandomization,
  generateWithoutFactorRandomization,
  replaceRandomizedSubject,
  getTotalRandomizedBySubject,
  getTotalRandomizedByEvent
};

function decryptResponse(encrypted) {
  const bytes = CryptoJS.AES.decrypt(encrypted, config.API_SECRET_KEY);
  const decrypted = bytes.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decrypted);
}

async function fetchWithConditions(APIURL, options) {
  const response = await fetch(APIURL, options);
  let json = await response.json();
  if (config.NODE_ENV === "production") {
    return decryptResponse(json.encrypted);
  } else {
    return await json;
  }
}

// Add Update Randomization Trail Design
async function addRandomizerStudyParameter(userData) {
  const APIURL = `${config.API_URL_USER_ONBOARDING}addRandomizerStudyParameter`
  const data = await fetchWithConditions(
    APIURL,
    headersWithAuth("POST", userData, headers)
  );
  if (data) await handleResponse(data);
  return data;
}

// Add New Study Randomizer Metadata
async function addNewRandomizerMetadata(userData) {
  const APIURL = `${config.API_URL_USER_ONBOARDING}addNewRandomizerMetadata`
  const data = await fetchWithConditions(
    APIURL,
    headersWithAuth("POST", userData, headers)
  );
  if (data) await handleResponse(data);
  return data;
}

// Update Study Randomizer Metadata
async function updateRandomizerMeta(userData) {
  const APIURL = `${config.API_URL_USER_ONBOARDING}updateRandomizerMeta`
  const data = await fetchWithConditions(
    APIURL,
    headersWithAuth("PUT", userData, headers)
  );
  if (data) await handleResponse(data);
  return data;
}

// Soft Delete & Restore Study Randomizer Metadata
async function softDeleteRestoreRandomizerMetadata(userData) {
  const APIURL = `${config.API_URL_USER_ONBOARDING}softDeleteRestoreRandomizerMetadata`
  const data = await fetchWithConditions(
    APIURL,
    headersWithAuth("PUT", userData, headers)
  );
  if (data) await handleResponse(data);
  return data;
}

// Delete Study Randomizer Metadata
async function deleteRandomizerMeta(userData) {
  const APIURL = `${config.API_URL_USER_ONBOARDING}deleteRandomizerMeta`
  const data = await fetchWithConditions(
    APIURL,
    headersWithAuth("DELETE", userData, headers)
  );
  if (data) await handleResponse(data);
  return data;
}

// Get Study Sequence Row Heighest version
async function getHeighestVersionEventFormSchemaHistory(studyId, randomizerId) {
  const APIURL = `${config.API_URL_USER_ONBOARDING}getHeighestVersionEventFormSchemaHistory/${studyId}/${randomizerId}`
  return fetchWithConditions(
    APIURL,
    headersWithAuthWithoutBody("GET", headers)
  );
}

// Find Randomization Trial Design
async function findRandomizerStudyParameter(studyId, randomizerId, StudyMode) {
  const APIURL = `${config.API_URL_USER_ONBOARDING}findRandomizerStudyParameter/${studyId}/${randomizerId}/${StudyMode}`
  return fetchWithConditions(
    APIURL,
    headersWithAuthWithoutBody("GET", headers)
  );
}

// Get Study Randomizer Metadata Row Audit Trial
async function getRandomizerMetadataAuditTrials(studyId, randomizerId) {
  const APIURL = `${config.API_URL_USER_ONBOARDING}getRandomizerMetadataAuditTrials/${studyId}/${randomizerId}`
  return fetchWithConditions(
    APIURL,
    headersWithAuthWithoutBody("GET", headers)
  );
}

// Get Assigned randomizer List
async function getAssignedRandomizerList(studyId, mode) {
  const APIURL = `${config.API_URL_USER_ONBOARDING}getAssignedRandomizerList/${studyId}/${mode}`
  return fetchWithConditions(
    APIURL,
    headersWithAuthWithoutBody("GET", headers)
  );
}

// Get Randomizer Metadata
async function getRandomizerMetadata(status, studyId, mode) {
  const APIURL = `${config.API_URL_USER_ONBOARDING}getRandomizerMetadata/${status}/${studyId}/${mode}`
  return fetchWithConditions(
    APIURL,
    headersWithAuthWithoutBody("GET", headers)
  );
}

// // Get Factors Based on Randomization Id
async function getFactorsBasedonRandomizationId(studyId, randomizerId) {
  const APIURL = `${config.API_URL_USER_ONBOARDING}getFactorsBasedonRandomizationId/${studyId}/${randomizerId}`
  return fetchWithConditions(
    APIURL,
    headersWithAuthWithoutBody("GET", headers)
  );
}

// Get Total Randomized By Subject
async function getTotalRandomizedBySubject(studyId, randomizerId, mode) {
  const APIURL = `${config.API_URL_USER_ONBOARDING}getTotalRandomizedBySubject/${studyId}/${randomizerId}/${mode}`
  return fetchWithConditions(
    APIURL,
    headersWithAuthWithoutBody("GET", headers)
  );
}

// Get Total Randomized By Event
async function getTotalRandomizedByEvent(studyId, randomizerId, mode) {
  const APIURL = `${config.API_URL_USER_ONBOARDING}getTotalRandomizedByEvent/${studyId}/${randomizerId}/${mode}`
  return fetchWithConditions(
    APIURL,
    headersWithAuthWithoutBody("GET", headers)
  );
}

// Generate With Factor Randomization
async function generateWithFactorRandomization(userData) {
  const APIURL = `${config.API_URL_USER_ONBOARDING}generateWithFactorRandomization`
  const data = await fetchWithConditions(
    APIURL,
    headersWithAuth("POST", userData, headers)
  );
  if (data) await handleResponse(data);
  return data;
}

// Generate Without Factor Randomization
async function generateWithoutFactorRandomization(userData) {
  const APIURL = `${config.API_URL_USER_ONBOARDING}generateWithoutFactorRandomization`
  const data = await fetchWithConditions(
    APIURL,
    headersWithAuth("POST", userData, headers)
  );
  if (data) await handleResponse(data);
  return data;
}

// Replace randomized Subject
async function replaceRandomizedSubject(userData) {
  const APIURL = `${config.API_URL_USER_ONBOARDING}replaceRandomizedSubject`
  const data = await fetchWithConditions(
    APIURL,
    headersWithAuth("POST", userData, headers)
  );
  if (data) await handleResponse(data);
  return data;
}